export default __webpack_public_path__ + "static/media/connecting_web-md@2x.0ab9a5aa.webp";